import React from 'react';
import {Router} from 'react-router-dom';

import {AiFeatureType} from 'nutshell-graphql-types';

import {appHistory} from '../../history';
import {call} from '../../phone';
import type {PhoneCallParameters} from '../../phone/call';

import {AiFeatureGateModal} from '../ai-home/ai-feature-gate-modal/ai-feature-gate-modal';
import {useGetSessionUser} from '../core/use-get-session-user';
import {CallSummarizationFeatureGateModal} from '../limits/feature-gates/call-summarization-feature-gate-modal';

import {InitiateCallWithOptionsPopover} from './initiate-call-with-options-popover';

export type PopoverData = {
    entityId: string;
    anchorElementId: string;
    rawPhoneNumber: string;
    formattedPhoneNumber: string;
};

/**
 * This component listens for when the click-to-call call button is clicked and then
 * renders the React click-to-call popover
 */
export function ClickToCallLegacyEventListener() {
    const [popoverData, setPopoverData] = React.useState<PopoverData | null | undefined>(null);
    const [isFeatureGateModalOpen, setIsFeatureGateModalOpen] = React.useState(false);

    const {user} = useGetSessionUser();

    React.useEffect(() => {
        $(window).on('showReactClickToCallPopover', handleOpenDialog);

        return () => {
            $(window).off('showReactClickToCallPopover', handleOpenDialog);
        };
    }, []);

    const handleOpenDialog = (e: any, data: PopoverData) => {
        setPopoverData(data);
    };

    const handleCloseDialog = () => {
        $(window).trigger('closeReactClickToCallPopover');
        setPopoverData(null);
    };

    const handleCall = (data: PhoneCallParameters) => {
        handleCloseDialog();
        call({
            entityId: data.entityId,
            phoneNumber: {
                E164: data.phoneNumber.E164,
                numberFormatted: data.phoneNumber.numberFormatted,
            },
            shouldRecord: data.shouldRecord,
            shouldTranscribe: data.shouldTranscribe,
            shouldSummarize: data.shouldSummarize,
        });
    };

    if (!user) {
        return null;
    }

    return (
        <>
            <Router history={appHistory}>
                {popoverData && (
                    <InitiateCallWithOptionsPopover
                        popoverData={popoverData}
                        handleCloseDialog={handleCloseDialog}
                        handleCall={handleCall}
                        user={user}
                        onOpenFeatureGate={() => setIsFeatureGateModalOpen(true)}
                    />
                )}
                {NutClientConfig.hasAiOutcomesFF ? (
                    <AiFeatureGateModal
                        isOpen={isFeatureGateModalOpen}
                        onClose={() => setIsFeatureGateModalOpen(false)}
                        reason='outOfCredits'
                        aiFeatureType={AiFeatureType.CLICK_TO_CALL_NOTETAKER}
                    />
                ) : (
                    <CallSummarizationFeatureGateModal
                        isOpen={isFeatureGateModalOpen}
                        onClose={() => setIsFeatureGateModalOpen(false)}
                    />
                )}
            </Router>
        </>
    );
}
